var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Upload the video for this content"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vid-up-wrapper" },
        [
          _c("Uploader", {
            staticClass: "vid",
            attrs: { caption: "", type: "video", "custom-clear": "" },
            on: { input: _vm.handleVideoUpload },
            model: {
              value: _vm.video,
              callback: function ($$v) {
                _vm.video = $$v
              },
              expression: "video",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.video
        ? [
            _c("p", { staticClass: "step-caption ft-bld" }, [
              _vm._v("Chose an auto generated cover or upload your own image"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cover-wrapper" },
              [
                _vm._l(_vm.autoCovers, function (cover, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "cover-card",
                      class: { active: _vm.activePoster == index },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.posterPick(index)
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "pic cvr",
                        style: { backgroundImage: "url(" + cover + ")" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon" }),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cover-card up",
                    class: { active: _vm.poster && _vm.activePoster == 4 },
                  },
                  [
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.poster && _vm.activePoster != 4,
                          expression: "poster && activePoster != 4",
                        },
                      ],
                      staticClass: "frt",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handlePosterUpload.apply(null, arguments)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Uploader", {
                      staticClass: "vid pstr",
                      attrs: {
                        caption: null,
                        "custom-caption": "Upload an image",
                        "custom-clear": "",
                      },
                      on: { input: _vm.handlePosterUpload },
                      model: {
                        value: _vm.poster,
                        callback: function ($$v) {
                          _vm.poster = $$v
                        },
                        expression: "poster",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon" }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn bck",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("prv")
              },
            },
          },
          [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("nxt")
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }